$ = require 'jquery'
h = require './helpers'
auth = require './../components/auth'
router = require './../components/router'

Checkbox = require './../components/checkbox'

tteStatuses = require './tte_statuses'

images_url = '//www.tourtrans.ru/js/online-styles/new/'

class OrderInfo
  elements: ->
    # Таблица "Услуги"
    this.$servicesTable = $('#ctl00_generalContent_TabContainer1_TabPanel1_serviceGrid_servicesTable')

    # Таблица с рассадкой, обозначениями и пр. Включает в себя всю информацию по рассадке
    this.$busFullTable = $('#ctl00_generalContent_TabContainer1_TabPanel1_busSeatingPlanControl_dgBusSeatingPlanControl')
    # Внешняя таблица плана рассадки (используется для рамки)
    # 1 ячейка в которой внутренняя таблица
    this.$busOuterTable = $('#ctl00_generalContent_TabContainer1_TabPanel1_busSeatingPlanControl_dgBusSeatingPlanControl_ctl02_dgPlans_ctl02_tblPlan')
    # Внутреняя таблица, с рассадкой
    this.$busTable = $('#ctl00_generalContent_TabContainer1_TabPanel1_busSeatingPlanControl_dgBusSeatingPlanControl_ctl02_dgPlans_ctl02_tblPlan table')
    # Кнопка подтверждания рассадки
    # Нужно эмулировать клик, т.к. на кнопке скрипт
    this.$submitBusButton = $('#ctl00_generalContent_TabContainer1_TabPanel1_busSeatingPlanControl_dgBusSeatingPlanControl_ctl02_dgPlans_ctl02_btnSavePlan')

    # Кнопка "Послать сообщение"
    this.$sendMessageButton = $('#ctl00_generalContent_TabContainer1_TabPanel1_btnSendMessage')

  formatPrice: ($span) ->
    str = $span.text()
    str = str.replace /\(.*\)/, ''
    str = str.replace 'Eu', 'у.е.'
    $span.text(str)

  findInput: (text) ->
    return $('input[value="' + text + '"]')

  renameInput: ($el, text) ->
    $el.val text
    return $el

  sendVizaDocuments: ->
    url = new URL(window.location.href)

    # dg_code = url.searchParams.get('dg_code')
    # replaced for winXP compatibility
    search = url.search
    if search.startsWith('?')
      search = search.substr(1)
    dg_code = new URLSearchParams(search).get('dg_code')

    console.log('Путевка', dg_code)

    email = $('.rfvTxtEmailreg span:eq(1)').text()
    username = auth.username()

    viza_docs = []
    $docs = $('.orderInfoPluginsList input')
    $docs.each (i, doc) ->
      $doc = $(doc)
      title = $doc.val()
      href = $doc.attr('href')
      if /виз/i.test(title)
        viza_docs.push
          title: title,
          href: href
#      console.log('Doc:', title, href)
#    console.log viza_docs

    data =
      dg_code: dg_code
      viza_docs: viza_docs
      email: email
      username: username
      type: router.site()

    params = $.param(data)
    console.log 'Params:', params
    $.getJSON '//www.tourtrans.ru/modules/sendVizaDocuments?' + params + '&jsoncallback=?', (data) ->
      console.log 'sendVizaDocuments', data

  getTourLink: ->
    $tourName = $ '#ctl00_generalContent_TabContainer1_TabPanel1_lbTourName'
    tourName = $tourName.text()
    tourCode = tourName.match /[\w\d\s-_]*/
    tourCode = tourCode[0].trim()
    console.log('Запрашаю ссылку на тур по коду:', tourCode)
    $.getJSON "//tourtrans.ru/api/getTourLink?code=" + tourCode + "&jsoncallback=?", (data) ->
      if data.url
        console.log 'Ссылка найдена: ' + data.url
        $tourName.replaceWith "<a target=\"blank\" href=\"#{data.url}\">#{tourName}</a>"
      else
        console.log 'Ссылка не найдена: ' + data.message

  getOneDayCategory: ->
    result = null
    $('#ctl00_generalContent_TabContainer1_TabPanel1_serviceGrid_servicesTable table tr td:nth-child(3)').each (i, e) ->
      console.log(i, e)
      $td = $(e)
      text = $td.text()
      m = text.match /категории ([АБВ])/
      if m
        result =  m[1]
    return result

  applyStyles: ->
#    return

    console.log 'Применяю стили OrderInfo'
    @getTourLink()
    @elements()
    $form = $('#aspnetForm')

#    $('body').addClass('order_info')

    $form.append h.h1n('Информация о заказе', 'h1-information')
    $row = h.row(false, 'information-content').appendTo $form
    $left = h.column('left').appendTo $row

    $blocks = $('.frontPanel table')

    [$info, $infoContent] = h.blockN('Информация')
    $info.appendTo $left
    $infoContent.append $blocks.eq(0)
    a = $('<a/>',{
      href: '/orderlist.aspx#documents'
    }).text('проверить актуальность')
    $('#ctl00_generalContent_TabContainer1_TabPanel1_lbAgentDogovor').empty().append(a);
    $('#ctl00_generalContent_TabContainer1_TabPanel1_lbAgentDogovorLoc').text('Договор:')

    [$prices, $pricesContent] = h.blockN('Стоимость')
    $prices.appendTo $left
    $pricesContent.append $('table.frontPanel')

    @formatPrice $('#ctl00_generalContent_TabContainer1_TabPanel1_lbPriceSum')
    @formatPrice $('#ctl00_generalContent_TabContainer1_TabPanel1_lbToPaySum')
    @formatPrice $('#ctl00_generalContent_TabContainer1_TabPanel1_lbDogovorCommission')
    @formatPrice $('#ctl00_generalContent_TabContainer1_TabPanel1_lbDeptSum')

    [$files, $filesContent] = h.blockN('Файлы')
    $files.appendTo $left
    $('#ctl00_generalContent_TabContainer1_TabPanel1_UploadFiles').appendTo($filesContent)
    $('#ctl00_generalContent_TabContainer1_TabPanel1_ListOfUploadedFiles').appendTo($filesContent)
    router = require './../components/router'
    html = ''
    if router.site() == 'online'
      html = '<br><br><div>К путевке можно прикрепить следующие документы (до 1 MB в формате jpg, jpeg, tiff, pdf):\n' +
        '<ol>\n' +
        '<li>Паспорт РФ: страница с данными + прописка при оформлении туров на Алтай и Байкал (для оформления страховки от клеща)</li>\n' +
        '<li>Копии авиа- или ж/д билетов, которые турист приобрел самостоятельно.</li>\n' +
        '<li>Загранпаспорт (при бронировании туров по Европе и ж/д туров в Калининград): копии страниц с фотографией и визами, в случае, если у туриста «своя» виза</li>\n' +
        '<li>Расписки: «О трехместном размещении», «Об отказе от медицинского страхования», «О своей визе», «Расписка о состоянии здоровья», «Анкета для проезда на поезде до Калининграда» и другие по требованию, заполненные туристом.</li>\n' +
        '</ol>\n' +
        '<span>Документы на оформление Визы просьба направлять на <a href="//www.tourtrans.ru/viza.html" target="_blank">email</a> c указанием номера заявки.</span>\n' +
        '<br><br>Просьба называть файлы в соответствии с содержанием. Пример «Виза», «Паспорт», «Билеты»</div>';
    if router.site() == 'personal'
      html = '<br><br><div>К путевке можно прикрепить следующие документы (до 1 MB в формате jpg, jpeg, tiff, pdf):\n' +
        '<ol>\n' +
        '<li>Паспорт РФ: страница с данными + прописка при оформлении туров на Алтай и Байкал (для оформления страховки от клеща).</li>\n' +
        '<li>Копии авиа- или ж/д билетов , которые турист приобрел самостоятельно.</li>\n' +
        '<li>Загранпаспорт (при бронировании туров по Европе и ж/д туров в Калининград): копии страниц с фотографией и визами, в случае, если у туриста «своя» виза.</li>\n' +
        '<li>Расписки: «О трехместном размещении», «Об отказе от медицинского страхования», «О своей визе», «Расписка о состоянии здоровья», «Анкета для проезда на поезде до Калининграда» и другие по требованию, заполненные туристом.</li>\n' +
        '</ol>\n' +
            '<span>Документы на оформление Визы просьба направлять на <a href="//www.tourtrans.ru/viza.html" target="_blank">email</a> c указанием номера заявки.</span>\n' +
        '<br><br>Просьба называть файлы в соответствии с содержанием. Пример «Виза», «Паспорт», «Билеты»</div>';
    $(html).appendTo($filesContent)

    $right = h.column('right').appendTo $row

    [$status, $statusContent] = h.blockN('Статус заказа', 'status')
    $status.appendTo $right
    [$columns, $l, $r] = h.columnsLR()
    $statusContent.append $columns
    $howToPay = $('.orderInfoPluginsList').find('input[value="Как оплатить?"]')
    $annulate = $('#ctl00_generalContent_TabContainer1_TabPanel1_btnAnnulate')
    $statusString = $('#ctl00_generalContent_TabContainer1_TabPanel1_LblOrderStatus')
    $img = $ '<img/>',
      src: images_url + '/green_check.svg'
    $l.append $img
    $l.append $statusString
    $r.append $howToPay
    $r.append $annulate
#    $statusContent.append $blocks.eq(1)

    [$payment, $paymentContent] = h.blockN('Оплата', 'payment')
    $payment.appendTo $right
    $ul = $ '<ul/>'
    $li = $ '<li/>'
    $payOnlineBtn = @findInput('Оплатить on-line')
    if not $payOnlineBtn.length
      $payOnlineBtn = $ '<input class="disabled"/>'
      $payOnlineBtn.val('Оплатить on-line')
    $li.append $payOnlineBtn
    $li.append @renameInput(@findInput('Как оплатить?'), 'Способы оплаты')
    $ul.append $li
    $ul.append @renameInput(@findInput('Распечатать счет'), 'Счёт на безнал').parent()
    $ul.append @renameInput(@findInput('Cчет Банк Открытие'), 'Счёт через Банк Открытие').parent()
    $paymentContent.append $ul

    [$docs, $docsContent] = h.blockN('Документы по путевке', 'docs')
    $docs.appendTo $right
    $docsContent.append $('.orderInfoPluginsList')
#    $div = $ '<div/>',
#      class: 'red'
#    $div.text 'Список отелей, памятка по присоединению, мед.страховка и пр. прикрепляются в Личный кабинет за 2-4 дня до начала тура!'
#    $docsContent.append $div

    $anketa = $('#ctl00_generalContent_TabContainer1_TabPanel1_btnAnkPrint')
    $files = $('#ctl00_generalContent_TabContainer1_TabPanel1_FileAttachmentList1_docTable')
    if $files.length or $anketa.length
      [$print, $printContent] = h.blockN('Распечатать документы для визы', 'print')
      $print.appendTo $right
      $printContent.append $anketa
      $printContent.append $files


    $form.append h.h1n('Информация о туристах', 'tourists')
    $form.append h.h1n('Состав заказа')
    $row = $ '<div></div>',
      class: 'row'
    $wrapper = $ '<div></div>',
      class: 'wrapper'
    $row.append $wrapper
    $form.append $row
    $wrapper.append this.$servicesTable

    # Блок "План рассадки пассажиров"
    if this.$busFullTable.length and $('#ctl00_generalContent_TabContainer1_TabPanel1_busSeatingPlanControl_dgBusSeatingPlanControl_ctl02_dgPlans_ctl02_tblPlan table tr').length > 2
      cat = @getOneDayCategory()
      if cat
        cats =
          'А':
            rows: [1, 10]
            cls: 'catA'
          'Б':
            rows: [11, 15]
            cls: 'catB'
          'В':
            rows: [16, 20]
            cls: 'catC'
        curCat = cats[cat]

        this.$busTable.addClass(curCat.cls)
        $(document).on 'click', '.quoteYes .checkbox-label', () ->
          $checkbox = $(this).closest('.quoteYes').find('input')
          $tr = $(this).closest('tr')
          row = $tr.index() - 1
          if $checkbox.prop('checked') and not (row >= curCat.rows[0] and row <= curCat.rows[1])
            alert('Место которое вы выбрали не соответствет ранее выбранной категории. При бронировании места из иной категории будет произведен перерасчет стоимости, после чего с Вами свяжется менеджер.')

      h.h1('План рассадки пассажиров', 'h1-bus').appendTo $form
      [$bus, $wrapper] = h.rowN(true, 'bus-content')
      $bus.appendTo $form
      $wrapper.append this.$busFullTable
      $checkboxes = this.$busTable.find('input[type="checkbox"]')
      $checkboxes.each (i, el) ->
        $el = $(el)
        $label = $el.parent().prev('span')
        new Checkbox($el, $label)
      $td = $('#ctl00_generalContent_TabContainer1_TabPanel1_busSeatingPlanControl_dgBusSeatingPlanControl > tbody > tr > td > table > tbody > tr > td').last()
      $footnote = $('<div/>')
      $ul = $('<ul/>')
      $ul.css
        paddingLeft: '16px'
        lineHeight: '24px'
      $ul.append '<li>Для одного туриста можно занять любое свободное место, за исключением случая, когда в автобусе уже заняты 2 одиночных места у окна (например, заняты места 8a и 4d).</li>'
      $ul.append '<li>При четном количестве человек туристов следует рассаживать парами – одно место у окна и одно у прохода.</li>'
      $ul.append '<li>Для нечетного количества человек: одного из туристов следует рассадить по правилам посадки для одного туриста, остальных парами.</li>'
      $ul.append '<li>Бронирование двух одиночных мест у окна друг за другом невозможно.</li>'
      $ul.append '<li>При количестве туристов в группе менее 15 человек может предоставляться микроавтобус -  иномарка туристического класса без кофеварки и туалета.</li>'
      $ul.append '<li>Места на последнем ряду предлагаются со скидкой (при подтверждении бронирования менеджер добавить скидку в стоимость тура).</li>'
      $footnote.append($ul)
      $td.append($footnote)



    h.h1n('Переписка с менеджером обслуживающим заказ').appendTo $form
    [$messages, $wrapper] = h.rowN(true)
    $messages.appendTo $form
    $wrapper.append $('#ctl00_generalContent_TabContainer1_TabPanel1_dgMessages')
    $wrapper.append $('.questionnaire_contentVariable')
#    $wrapper.append $('#ctl00_generalContent_TabContainer1_TabPanel1_LbMessageRuleType')

    [$msgForm, $wrapper] = h.rowN(true, 'message-form')
    $msgForm.appendTo $form
    $wrapper.append $('#ctl00_generalContent_TabContainer1_TabPanel1_txtMessage')
    $wrapper.append $('#ctl00_generalContent_TabContainer1_TabPanel1_revMaxLength')
    $wrapper.append this.$sendMessageButton
    this.$sendMessageButton.val('Отправить')

    $('.importToMasterAgentLink').closest('li').remove()

    @tourists_list()

  tourists_list: ->
    $row = $('<div class="row"></div>')
    $wrapper = $('<div class="wrapper"></div>')
    $row.append $wrapper
    $cont = $('<div class="tourists-list"></div>')
    $wrapper.append $cont
    $row.insertAfter($('.tourists').parent())

    $table = $('#ctl00_generalContent_TabContainer1_TabPanel1_dogovorTouristData_dgTourists')
    $rows = $table.find('tr')
    headers = {}
    $rows.each (i, e) ->
#      return
      if i == 0
        $cols = $(e).find('td')
        $cols.each (index, elem) ->
          headers[index] = $(elem).html().replace('<br>', ' ')
        console.log 'headers', headers
      else
        $tourist = $ '<div/>',
          class: 'tourist-item'
        $cont.append($tourist)

        $data = $ '<div/>',
          class: 'tourist-data'
        $tourist.append(h.h2('<img src="' + images_url + 'icon_tourist.svg">Турист ' + i, 'h2-tourist'))
        $tourist.append $data

        $cols = $(e).find('td')
        $cols.each (index, elem) ->
          header = headers[index]
          $content = $(elem).children()

          iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

          $actions = $(elem).find('a')
          if $actions and not iOS
            $actions.each (ai, action) ->
              $action = $(action)
              id = $action.attr('id')
              console.log '*id', id
              tmp = id.split('_')
              klass = tmp[tmp.length - 1]
              console.log klass

              if klass == 'btnEdit'
                $action.appendTo($tourist.find('h2')).addClass('edit')

              if klass == 'btnSave'
                $action.appendTo($tourist.find('h2')).addClass('save')

              if klass == 'btnCancel'
                $action.appendTo($tourist.find('h2')).addClass('cancel')


          $id = $(elem).find('span:last-child')
          id = $id.attr('id')

          if id
            tmp = id.split('_')
            klass = tmp[tmp.length - 1]
            $row = $ '<div></div>',
              class: klass
            $row.append '<b>' + header + '</b>'
            $row.append $content

            $data.append $row
  #          field_class = 'none'
  #          $input = $(elem).find('select, input')
  #          if $input
  #            input_name = $input.attr('name')
  #            if input_name
  #              tmp = input_name.split('$')
  #              field_class = tmp[tmp.length - 1]
  #          $row = $('<div class="' + field_class + '"><label>' + header + '</label></div>')
  #
  #          $row.append(content)
  #          $data.append($row)

        $common = $ '<div></div>',
          class: 'row'
        $data.append $common

        $passports = $ '<div></div>',
          class: 'row'
        $data.append $passports

        $more = $ '<div></div>',
          class: 'row'
        $data.append $more

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $common.append($columns)

        $data.find('.lastnamerus').appendTo($left)
        $data.find('.firstnamerus').appendTo($left)
        $data.find('.patronymicrus').appendTo($left)
        $data.find('.lastname').appendTo($left)
        $data.find('.firstname').appendTo($left)
        $data.find('.cvBirthDate').appendTo($right)
        $data.find('.sex').appendTo($right)
        $data.find('.birthplace').appendTo($right)
        $data.find('.rfvTxtEmailreg').appendTo($right)
        $data.find('.phone').appendTo($right)

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $passports.append($columns)

        $data.find('.passportrus').appendTo $left
        $data.find('.citizenship').appendTo $left
        $data.find('.passport').appendTo $right
        $data.find('.passportdateend').appendTo $right

        $columns = $ '<div/>',
          class: 'columns'
        $left = $ '<div/>',
          class: 'col-1'
        $right = $ '<div/>',
          class: 'col-2'
        $columns.append($left)
        $columns.append($right)
        $more.append($columns)

        $data.find('.visaStatus').appendTo $left
        $data.find('.lbNumber').appendTo $right

    status = $('#ctl00_generalContent_TabContainer1_TabPanel1_LblOrderStatus').text()
    console.log('Статус заявки', status)
    if status == 'WEB-ТУРАГЕНТ'
      console.log('Отправляю документы')
      @sendVizaDocuments()

    statusDescriptions = {
      'WEB-ТУРАГЕНТ': 'Заявка принята. Мы уже работаем с заказом. Ниже в разделе План рассадки пассажиров забронируйте место в автобусе.',
      'ОК ОПЛАЧЕНО': 'Заказ оплачен. Готовьтесь к туру. Информация по встрече в разделе «Отправление».',
      'УВЕДОМЛЕНИЕ SINGLE': 'Подселение в отеле не найдено. Для вас специальное предложение одноместное размещение за 50%. Подтвердите согласие и доплатите за услугу.',
      'БЕЗ АВИАБИЛЕТА': 'Заявка подтверждена на тур без авиаперелета. Можете переходить к оплате. Сообщите ваши полетные данные.',
      'БЕЗ АВИАБИЛЕТА 1 ЧЕЛ.': 'Заявка подтверждена на тур без авиаперелета. Можете переходить к оплате. Сообщите ваши полетные данные.',
      'БЕЗ АВИАБИЛЕТА 2 ЧЕЛ.': 'Заявка подтверждена на тур без авиаперелета. Можете переходить к оплате. Сообщите ваши полетные данные.',
      'УВЕДОМЛЕНИЕ КАЮТА': 'Подселение в каюте на пароме не найдено. Для вас специальное предложение на размещение в каюте. Подтвердите согласие и доплатите за услугу.',
      'ДОКУП АВИАБИЛЕТА': 'Заявка подтверждена. Блок мест на авиаперелёт исчерпан. Для вас куплен индивидуальный авиабилет. Аннуляция билета по условиям авиакомпании.',
      'ПРЕД. ПОДТВЕРЖДЕНИЕ': 'Заказ подтвержден. Вы можете оплачивать заказ в разделе «Оплатить» и готовиться к туру. Информация по встрече в разделе «Отправление».',
      'ЛИСТ ОЖИДАНИЯ': 'Закончились места. Заказ поставлен на лист ожидания. С вами свяжутся, как только освободится место.',
      'ГРУППА АННУЛИРОВАНА': 'Временное бронирование на 1 сутки на место в автобусе. Для формирования подтверждения заказа необходимо подтвердить бронирование и выбрать услуги.',
      'ЗАПРОС': 'Исчерпан блок авиа или ж/д билет. Мы ищем для вас подходящий вариант и сообщим как он будет найден.',
      'ДОКУП АВИАБИЛЕТА 1 ЧЕЛ.': 'Заявка подтверждена. Блок мест на авиаперелёт исчерпан. Для вас куплен индивидуальный авиабилет. Аннуляция билета по условиям авиакомпании.',
      'АКЦИЯ ДО 01.09.20…': 'Ваша заявка участвует в Акции. До обозначенного срока необходимо подтвердить свой заказ, выбрать услуги и оплатить.',
      'ЗАПРОС НА Ж/Д ПЕРЕЕЗД': 'Ищем для вас подходящий вариант железнодорожных билетов и сообщим как он будет найден.',
      'НЕ ВЫПОЛНЯЕТСЯ': 'Группа расформирована. Альтернативные варианты предложены в информационном письме. Сообщите о вашем решении.',
      'КЭШБЭК': 'Ваша заявка участвует в Акции КЭШБЭК',
    }

    description = statusDescriptions[status]
    if description
      $('.status .wrapper').append $("<div class=\"description\">#{description}</div>")

    # $payOnlineBtn = @findInput('Оплатить on-line')
    $payOnlineBtn = $('.payment input[class="disabled"]')
    console.log('Найдена кнопка оплаты', $payOnlineBtn)
    if router.site() == 'personal' and tteStatuses.indexOf(status) != -1
      code = $('#ctl00_generalContent_TabContainer1_TabPanel1_lbDogovorCode').text().trim()
      console.log('Код заказа', code)
      payUrl = "javascript:window.open('//personal.tourtrans.ru/yookassatte/Payment.aspx?orderCode=" + code + "&action=login', 'PaymentSystem');"
      console.log('Ссылка на оплату', payUrl)
      $payOnlineBtn.val('Оплатить on-line')
      $payOnlineBtn.attr('onclick', payUrl)
      $payOnlineBtn.removeClass('disabled')
      $payOnlineBtn.attr('type', 'button')
      console.log('Ссылка на оплату установлена')
      # if payUrl && payUrl.length > 0
      #   payUrl = payUrl.replace('Sberbank', 'Sberbanktte')
      #   $payOnlineBtn.attr('onclick', payUrl)

module.exports = new OrderInfo
